module.exports = __webpack_public_path__ + "left2.341385f7ba8f4452f4d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/left2.svg
// module id = 1294
// module chunks = 2